import Field from 'Pages/Dashboard/Settings/FieldsManagement/Fields/FieldTypes/Field';
import React from 'react';
import { connect } from 'react-redux';
import { ADDRESS, getAddressDataset } from 'Services/AddressFieldService/AddressFieldService';
import { FieldType, getFieldTypeLabel } from 'Store/FieldManagement/PropTypes';
import { getDatasetLabels } from 'Store/FieldManagement/Selectors';
import { StoreState } from 'Store/Reducers';
import { getFieldsByEntityIdAsArray, getFieldsByEntityIdAsObject } from 'Store/Settings/Fields/Selectors';
import { getValuesByEntityNameByEntityId, isEntityFetching, isEntityPatching } from 'Store/Shared/Store/Values/Selector';

const DisplayName = ({
    value, isEdit, onChange,
    entity, valueByFieldId, fieldsById, fields, datasetLabels,
    isEntityFetching, isEntityPatching,
    ...props
}: DisplayNameProps) => {
    if (isEntityFetching) return <></>;

    if (typeof isEdit === 'undefined') {
        return <>
            {
                entity?.name_fields?.map((uuid: any, idx: number, arr: any[]) => {
                    const spacing = idx != arr.length-1 ? ' ' : '';
                    if (!uuid.includes('+')) {
                        let outputValue = ({ ...valueByFieldId?.[uuid] })?.value;

                        const isDropdown = Array.isArray(outputValue);
                        if (isDropdown) outputValue = datasetLabels?.[outputValue[0]] || '';

                        return (outputValue || '') + spacing;
                    }

                    const uuidArray = uuid.split('+');
                    const fieldId = uuidArray[0];
                    const valueId = uuidArray[1];

                    if (!valueByFieldId?.[fieldId]) return spacing;

                    const outputValue = valueByFieldId?.[fieldId]?.value?.[valueId];
                    return (outputValue || '') + spacing;
                })
            }
        </>
    }
    
    return <>
        { !isEdit && entity?.name_fields?.map((uuid: any, idx: number, arr: any[]) => {
            const spacing = idx != arr.length-1 ? ' + ' : '' ;
            if (!uuid.includes('+')) return fieldsById?.[uuid]?.name + spacing;
            
            const secondId = uuid.split('+')[1];
            return ADDRESS?.[secondId] + spacing;
        }) }

        {
            isEdit
            && onChange
            && <Field
                isEdit={true}
                type={FieldType.MultiSelect}
                value={value}
                onChange={(value: any) => onChange(value)}
                fieldProperties={{
                    disableAlphabeticOrder: true,
                    list: fields
                        .filter((i) => i.type == FieldType.Address
                            || i.type == FieldType.Dropdown
                            || i.type == FieldType.Text
                        )
                        .map((field: any) => {
                            const output = {
                                label: `${field?.name} (${getFieldTypeLabel(field?.type)})`,
                                value: field?.id
                            }
                            if (field.type == FieldType.Address) {
                                return {
                                    ...output,
                                    children: getAddressDataset(field?.id)
                                }
                            }

                            return output;
                        }),
                    helper: "Alleen type 'Adres', 'Dropdown', 'Tekst' mogelijk"
                }}
            />
        }
    </>;
}

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    entity: any,
    entity_id?: any,
    value?: any,
    isEdit?: boolean
}

const mapState = (state: StoreState, props: Props) => ({
    fieldsById: getFieldsByEntityIdAsObject(state, props?.entity?.id),
    fields: getFieldsByEntityIdAsArray(state, props?.entity?.id),
    valueByFieldId: getValuesByEntityNameByEntityId(state, props?.entity?.name, props?.entity_id),
    isEntityFetching: isEntityFetching(state, props?.entity?.name, props?.entity_id),
    isEntityPatching: isEntityPatching(state, props?.entity?.name),
    datasetLabels: getDatasetLabels(state)
});

const mapDispatch = {

}

type DisplayNameProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(DisplayName);